import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  totalStudents: 0,
  maleStudentCount: 0,
  femaleStudentCount: 0,
  totalTeachers: 0,
  maleTeacherCount: 0,
  femaleTeacherCount: 0,
  totalClasses: 0,
  juniorClassCount: 0,
  seniorClassCount: 0,
  loading: false,
  error: null,
};

const adminDataSlice = createSlice({
  name: 'adminData',
  initialState,
  reducers: {
    setAdminData: (state, action) => {
      const data = action.payload;
      state.totalStudents = data.totalStudents || 0;
      state.maleStudentCount = data.maleStudentCount || 0;
      state.femaleStudentCount = data.femaleStudentCount || 0;
      state.totalTeachers = data.totalTeachers || 0;
      state.maleTeacherCount = data.maleTeacherCount || 0;
      state.femaleTeacherCount = data.femaleTeacherCount || 0;
      state.totalClasses = data.totalClasses || 0;
      state.juniorClassCount = data.juniorClassCount || 0;
      state.seniorClassCount = data.seniorClassCount || 0;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearAdminData: (state) => {
      state.totalStudents = 0;
      state.maleStudentCount = 0;
      state.femaleStudentCount = 0;
      state.totalTeachers = 0;
      state.maleTeacherCount = 0;
      state.femaleTeacherCount = 0;
      state.totalClasses = 0;
      state.juniorClassCount = 0;
      state.seniorClassCount = 0;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setAdminData, setLoading, setError, clearAdminData } = adminDataSlice.actions;

export default adminDataSlice.reducer;